import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { EmergencyIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import useTranslate from '../../../lib/hooks/use-translate'
import { StaffInput } from '../../../lib/types/models/staff/staff-input'
import TextBreakWrapper from '../../elements/break-wrapper'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import IconBox from '../../elements/icon-box'
import InformationToolTip from '../../elements/information-tooltip'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledPhoneInput from '../../elements/inputs/controlled-phone-input'

const StaffPersonalSpaceEmergencyForm = () => {
  const form = useFormContext<StaffInput>()
  const { t } = useTranslate()

  return (
    <IconBox
      title={
        <div className="flex items-center gap-4">
          <Typography variant="h6" color={tailwindColors.black.DEFAULT}>
            {t('staff.personal.space.in.case.of.emergency')}
          </Typography>
          <InformationToolTip>
            <TextBreakWrapper
              translationKey="staff.personal.space.in.case.of.emergency.info"
              variant="label-semibold"
              color={tailwindColors.white.DEFAULT}
            />
          </InformationToolTip>
        </div>
      }
      icon={EmergencyIcon}
    >
      <span id="staff-personal-space-emergency-contact" className="block h-0" />
      <div className="h-3" />
      <div className="grid grid-cols-3 gap-3 mobile:grid-cols-1">
        <FormField
          control={form.control}
          name="emergencyContactName"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledInput
                  {...field}
                  label={t('staff.personal.space.emergency.contact.name')}
                  type="text"
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="emergencyContactRelationship"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledInput
                  {...field}
                  label={t('staff.personal.space.emergency.contact.relationship')}
                  type="text"
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="emergencyContactPhoneNumber"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledPhoneInput
                  {...field}
                  label={t('staff.personal.space.phone.number')}
                  defaultCountry="FR"
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </IconBox>
  )
}

export default StaffPersonalSpaceEmergencyForm
